import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
class WholesaleLimitDetailResource extends BaseCamelCasedResource {
    pk() {
        return `${this.applicationNumber}`;
    }
}
WholesaleLimitDetailResource.urlRoot = apiResourceUrl("wholesaleLimit/{vendorId}/detail");
export { WholesaleLimitDetailResource };
//# sourceMappingURL=WholesaleLimitDetailResource.js.map